import React from 'react';
import {Flex} from "antd";

import Stages from "../../brief/Stages";

export default function BriefStages() {
  return (
    <Flex vertical gap={4} style={{padding: '16px 8px 14px 16px'}}>
      <Stages />
    </Flex>
  )
}
